module.exports = __webpack_public_path__ + "media/feedback-4-e361fbed0c07866a772e1d3e9f7cdb11.png";